/** Shared formatting and type-coercion utilities. */

export function safeString(value: unknown): string {
  return typeof value === 'string' ? value : value == null ? '' : String(value);
}

export function toNumber(value: unknown): number {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const normalized = value.replace(/\s/g, '').replace(',', '.');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
}

export function formatCurrency(value: number): string {
  const rounded = Math.round((Number.isFinite(value) ? value : 0) * 100) / 100;
  const hasCents = !Number.isInteger(rounded);
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(rounded);
}

export function formatNativeCurrency(value: number, currency: string): string {
  const normalizedCurrency = safeString(currency).trim().toUpperCase();
  if (normalizedCurrency === 'EUR') return formatCurrency(value);
  if (!normalizedCurrency) {
    return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })} · devise non renseignée`;
  }
  try {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: normalizedCurrency,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })} ${normalizedCurrency}`;
  }
}

export function formatDays(value: number): string {
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded)
    ? rounded.toLocaleString('fr-FR', { maximumFractionDigits: 0 })
    : rounded.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

export function formatPercent(value: number): string {
  const normalized = value > 1 ? value : value * 100;
  return `${normalized.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} %`;
}
